import useAuth from "../../../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { CustomButton } from "../../../atoms/CustomButton";
import { useGetEntityPreferencesByPath } from "../../../../hooks/entity";
import QRCodeGenerator, {
  QRCodeGeneratorHandle,
} from "../../../atoms/QRCodeGenerator";

const CreateUserQrCode = () => {
  const [t] = useTranslation();
  const qrGeneratorRef = useRef<QRCodeGeneratorHandle>(null);
  const { user, customer_identification } = useAuth();
  const { data: res } = useGetEntityPreferencesByPath(
    customer_identification,
    user.entity_identification,
    "cdn_logo_project_path"
  );

  const handleDownloadQrCode = async () => {
    if (!qrGeneratorRef.current) return;

    try {
      const blob = await qrGeneratorRef.current.getBlob("png");
      if (blob) {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `create-user-${user.entity_identification}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="w-full">
      <center className="w-full mb-4">
        <QRCodeGenerator
          ref={qrGeneratorRef}
          data={`${process.env.REACT_APP_HOST_URL}/user/${user.entity_identification}/registration`}
          size={250}
          showLogo={true}
          logoUrl={
            res?.cdn_logo_project_path ||
            "https://cdn.1cdn.app/application/UMD/2405110558455_logo.png"
          }
          ariaLabel={`QR code for user registration: ${user.entity_identification}`}
        />
      </center>

      <div className="d-flex justify-content-center align-items-center">
        <CustomButton
          variant="primary"
          className="w-full"
          onClick={handleDownloadQrCode}
          title={t("dashboard.createUserQr.btn-02") as string}
        />
      </div>
    </div>
  );
};

export default CreateUserQrCode;
